import { getUrl, getApi } from './api'
import { getReq, postReq } from './appService'

// 获取详情信息
export const getArtistInfo = (chainId: number, params: any, cb: any) => {
  let url = getUrl('/v1/user', chainId, params)
  getReq(url, cb)
}

// 获取详情信息
export const getArtist = (chainId: number, params: any, cb: any) => {
  let url = getUrl('/v2/user', chainId, params)
  getReq(url, cb)
}

// 创建/更新
export const addArtists = (chainId: number, params: any, cb: any) => {
  const url = getApi(chainId) + '/v1/user'
  postReq(url, params, cb)
}

// 获取首页卖的最好的Aritists前十列表
export const getBestAritists = (chainId: number, params: any, cb: any) => {
  const url = getUrl('/v3/user', chainId, params)
  getReq(url, cb)
}

// 获取首页卖的最好的Collectors前十列表
export const getBestCollectors = (chainId: number, params: any, cb: any) => {
  const url = getUrl('/v3/user', chainId, params)
  getReq(url, cb)
}